import React, { memo } from 'react';
import { processInt, processNum, processStr, validateEmail } from '../../../global';
import { deepEqual, isNormalInteger, isPositiveFloat } from '../../../utils/util';

const Row = ({ index, x, services, destinations, user, autoCN, updateGrid, ct, rt,  calltracks, reattempts }) => {
    return <tr key={index}>
        <td>{index + 1}</td>

        <td><input disabled={true} style={{ width: 170 }} maxLength={15} id={`ticketNo${index + 1}`} className={x.ticketNo == '' ? "form-control is-invalid" : "form-control"} defaultValue={x.ticketNo} onInput={processNum} onBlur={(e) => updateGrid(index, 'ticketNo', e.target.value)} /></td>
        
        <td><input disabled={true} style={{ width: 170 }} maxLength={15} id={`cn${index + 1}`} className={x.cn == '' ? "form-control is-invalid" : "form-control"} defaultValue={x.cn} onInput={processNum} onBlur={(e) => updateGrid(index, 'cn', e.target.value)} /></td>

        
        <td>
            <select style={{ minWidth: 160 }} id={`ShipperAdvice${index + 1}`} type="text" className={ct.filter(y => y.toUpperCase() == (x.ShipperAdvice && x.ShipperAdvice.toUpperCase())).length == 0 ? "form-select is-invalid bulk-select" : "form-select"} value={x.ShipperAdvice.toUpperCase()} onChange={(e) => {
                updateGrid(index, 'ShipperAdvice', e.target.value)


                const advice = calltracks.filter(i => i.text.toUpperCase() == e.target.value)


                updateGrid(index, 'advice', advice.length == 0 ? 0 : Number(advice[0].value))
            }}>
                <option value="">Select Advice Type</option>
                {
                    ct.map((y, index2) => <option key={index2} value={y.toUpperCase()}>{y}</option>)
                }
            </select>
        </td>


        <td>
            <select style={{ minWidth: 160 }} id={`ActionRequired${index + 1}`} disabled={!(x.advice == 3)} type="text" className={rt.filter(y => y.toUpperCase() == (x.ActionRequired && x.ActionRequired.toUpperCase())).length == 0 ? `form-select ${!(x.advice == 3) ? '' : 'is-invalid'} bulk-select` : "form-select"} value={x.ActionRequired.toUpperCase()} onChange={(e) => {
                updateGrid(index, 'ActionRequired', e.target.value)
                
                if(e.target.value) {
                    const reattempt = reattempts.filter(i => i.text.toUpperCase() == e.target.value)    
                    updateGrid(index, 'reattemptReason', reattempt.length == 0 ? 0 : Number(reattempt[0].value))
                    updateGrid(index, 'newConsigneePhone', Number(reattempt[0].value) == 2 ? '' : x.consigneeContact)
                    updateGrid(index, 'newConsigneeAddress', Number(reattempt[0].value) == 2 ? '' : x.consigneeAddress)
                }
            }}>
                <option value="">Select Re Attempt Reason</option>
                {
                    rt.map((y, index2) => <option key={index2} value={y.toUpperCase()}>{y}</option>)
                }
            </select>
        </td>

{
    x.reattemptReason == 2 ?  
        <td>
            <input 
                key={`newConsigneePhone${index + 1}`}
                style={{ width: 170 }} 
                name={`newConsigneePhone${index + 1}`} 
                maxLength={50} 
                id={`newConsigneePhone${index + 1}`} 
                className={x.newConsigneePhone == '' ? "form-control is-invalid" : "form-control" } 
                defaultValue={x.newConsigneePhone} 
                onBlur={(e) => {
                    updateGrid(index, 'newConsigneePhone', e.target.value)
                }} 
                />
        </td> 
        
        :  
        
        <td><input key={`consigneeContact${index + 1}`} style={{ width: 170 }} maxLength={50} name={`consigneeContact${index + 1}`} id={`consigneeContact${index + 1}`} readOnly={true} className={x.reattemptReason == 2 ? x.newConsigneePhone == '' ? "form-control is-invalid" : "form-control" : x.consigneeContact == '' ? "form-control is-invalid" : "form-control"} defaultValue={x.consigneeContact} onBlur={(e) => {
        updateGrid(index, 'consigneeContact', e.target.value)
    }} /></td>
}


{
    x.reattemptReason == 2 ?  
        <td><input key={`newConsigneeAddress${index + 1}`} style={{ width: 170 }} maxLength={255} id={`newConsigneeAddress${index + 1}`} readOnly={!(x.reattemptReason == 2)} className={x.reattemptReason == 2 ? x.newConsigneeAddress == '' ? "form-control is-invalid" : "form-control" :  x.consigneeAddress == '' ? "form-control is-invalid" : "form-control"} defaultValue={x.newConsigneeAddress} onBlur={(e) => updateGrid(index, 'newConsigneeAddress', e.target.value)} /></td>
        
        :  
        
        <td><input key={`consigneeAddress${index + 1}`} style={{ width: 170 }} maxLength={255} id={`consigneeAddress${index + 1}`} readOnly={true} className={x.reattemptReason == 2 ? x.newConsigneeAddress == '' ? "form-control is-invalid" : "form-control" :  x.consigneeAddress == '' ? "form-control is-invalid" : "form-control"} defaultValue={x.consigneeAddress} onBlur={(e) => updateGrid(index, 'consigneeAddress', e.target.value)} /></td>

}

       
        <td><input style={{ width: 170 }} maxLength={400} id={`Remarks${index + 1}`} className={"form-control"} defaultValue={x.Remarks} onBlur={(e) => updateGrid(index, 'Remarks', e.target.value)} /></td>
        
    </tr>
}

const MemoRow = memo(Row, (prv, nxt) => {
    return deepEqual(prv.x, nxt.x);
});


export default MemoRow;


